
import {initWebComponent} from "@/helpers/web-component-helper";
import {reloadFilterDataTable} from "@/helpers/datatable-filter-helper";
import {
    applyFilter, getActiveFilter, getFilterGeometryType,
    setFilterGeometry,
} from "@/helpers/filter/filter-helper";
import {resizeDataTableFilter} from "@/components/layer/info/filter/layer-info-filter-result-component";
import {getBySelector, hideElementsBySelector} from "@/helpers/element-helper.js";
import {getDataTableFilterSettings} from "@/helpers/filter/filter-settings-helper.js";
import {showNotification} from "@/helpers/notification-helper.js";

export class LayerInfoFilterSettingsApplyButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<button class="btn btn-outline-secondary btn-sm btn-block">Toepassen</button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            //

            console.log('check required')

            const activeFilter = getActiveFilter()
            const filterData  = getDataTableFilterSettings(window.filterData)

            console.log(filterData)
            console.log(activeFilter)

            let emptyRequiredAttributes = []

            activeFilter.form.form_attributes.map( (formAttribute, key) => {
                if(formAttribute.IsRequired) {
                    const column = filterData.columns.find(column => column.data === formAttribute.attribute.Attribute)

                    if(formAttribute.attribute.Type === 21) {
                        if(getFilterGeometryType() === '') {
                            console.log('must have geom is empty but required')
                            emptyRequiredAttributes.push(key)
                        }
                    } else {
                        if (column.search.value === '') {
                            console.log('is empty but required')
                            emptyRequiredAttributes.push(key)
                        }
                    }
                }
            })

            if(emptyRequiredAttributes.length > 0) {

                emptyRequiredAttributes.map(emptyRequiredAttribute => {
                    const element = getBySelector(`layer-info-filter-settings div[data-header-key='${emptyRequiredAttribute}']`)
                    element.classList.add('border-danger')
                })

                showNotification('Vul alle verplichten velden in', '', 'warning')
            } else {
                applyFilter()
            }


            hideElementsBySelector('#btnShowFilterLayers')
        })
    }
}

